import { ArrowRight, CheckCircle2, Star, Phone, Package, Shield, Box, ChevronDown, Truck, ShoppingBag, AlertTriangle, Sparkles } from 'lucide-react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Contact from '../components/Contact';

export default function Verpackungsmaterial() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('kontakt');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const benefits = [
    'Professionelles Umzugsmaterial in Top-Qualität',
    'Umweltfreundliche und wiederverwendbare Materialien',
    'Kostenlose Lieferung ab CHF 200.–',
    'Rücknahme gebrauchter Kartons möglich',
    'Spezialverpackungen für empfindliche Güter',
    'Mengenrabatte bei grösseren Bestellungen',
  ];

  const materials = [
    {
      icon: Box,
      title: 'Umzugskartons',
      items: [
        { name: 'Standard-Karton (60x33x34cm)', price: 'CHF 3.50' },
        { name: 'Bücher-Karton (40x30x30cm)', price: 'CHF 3.00' },
        { name: 'Kleider-Karton mit Stange', price: 'CHF 12.00' },
        { name: 'Gläser-Karton mit Einsatz', price: 'CHF 8.50' },
      ],
      description: 'Stabile, zweiwellige Kartons für sicheren Transport',
    },
    {
      icon: Shield,
      title: 'Schutzverpackungen',
      items: [
        { name: 'Luftpolsterfolie (100m Rolle)', price: 'CHF 28.00' },
        { name: 'Packpapier (10kg Bündel)', price: 'CHF 18.00' },
        { name: 'Möbeldecken (1 Stück)', price: 'CHF 12.00' },
        { name: 'Stretchfolie (500m Rolle)', price: 'CHF 22.00' },
      ],
      description: 'Optimaler Schutz für empfindliche Gegenstände',
    },
    {
      icon: Package,
      title: 'Hilfsmittel',
      items: [
        { name: 'Klebeband (66m Rolle)', price: 'CHF 4.50' },
        { name: 'Edding wasserfest', price: 'CHF 3.00' },
        { name: 'Kartonmesser', price: 'CHF 5.00' },
        { name: 'Etiketten Set (100 Stück)', price: 'CHF 8.00' },
      ],
      description: 'Alles was Sie zum Verpacken brauchen',
    },
    {
      icon: Sparkles,
      title: 'Spezialverpackungen',
      items: [
        { name: 'Bilderschutz-Kartons', price: 'ab CHF 15.00' },
        { name: 'TV-Kartons (verschiedene Grössen)', price: 'ab CHF 25.00' },
        { name: 'Matratzen-Schutzhülle', price: 'CHF 18.00' },
        { name: 'Spiegel-Ecken (4er Set)', price: 'CHF 12.00' },
      ],
      description: 'Spezielle Lösungen für wertvolle Gegenstände',
    },
  ];

  const packages = [
    {
      name: 'Starter-Paket',
      ideal: '1-2 Zimmer Wohnung',
      price: 'CHF 95.–',
      contents: [
        '15x Standard-Kartons',
        '5x Bücher-Kartons',
        '1x Luftpolsterfolie (50m)',
        '1x Packpapier (5kg)',
        '3x Klebeband',
        '1x Edding',
      ],
    },
    {
      name: 'Standard-Paket',
      ideal: '3-4 Zimmer Wohnung',
      price: 'CHF 185.–',
      popular: true,
      contents: [
        '30x Standard-Kartons',
        '10x Bücher-Kartons',
        '2x Kleider-Kartons',
        '1x Luftpolsterfolie (100m)',
        '1x Packpapier (10kg)',
        '6x Klebeband',
        '2x Edding',
        '1x Etiketten Set',
      ],
    },
    {
      name: 'Premium-Paket',
      ideal: '5-6 Zimmer Haus',
      price: 'CHF 340.–',
      contents: [
        '50x Standard-Kartons',
        '15x Bücher-Kartons',
        '4x Kleider-Kartons',
        '2x Gläser-Kartons',
        '2x Luftpolsterfolie (100m)',
        '2x Packpapier (10kg)',
        '4x Möbeldecken',
        '10x Klebeband',
        '3x Edding',
        '2x Etiketten Sets',
      ],
    },
  ];

  const whyChooseUs = [
    {
      icon: Shield,
      title: 'Top-Qualität',
      description: 'Wir verwenden nur hochwertige, stabile Verpackungsmaterialien. Unsere zweiwelligen Kartons sind extrem belastbar und schützen Ihre Gegenstände optimal bei Umzügen wie Umzug Zürich Deutschland oder Firmenumzügen.',
    },
    {
      icon: Truck,
      title: 'Schnelle Lieferung',
      description: 'Bestellung bis 12 Uhr = Lieferung am nächsten Werktag. Kostenlose Lieferung ab CHF 200.–. In dringenden Fällen auch Express-Lieferung am gleichen Tag möglich.',
    },
    {
      icon: Package,
      title: 'Umweltfreundlich',
      description: 'Alle Kartons sind recyclebar und aus nachhaltiger Produktion. Nach Ihrem Umzug nehmen wir gebrauchte Kartons gerne zurück – für die Wiederverwendung.',
    },
    {
      icon: ShoppingBag,
      title: 'Mengenrabatte',
      description: 'Bei grösseren Bestellungen profitieren Sie von attraktiven Rabatten. Ab 50 Kartons erhalten Sie 10% Nachlass, ab 100 Kartons sogar 15% Rabatt.',
    },
  ];

  const packingTips = [
    {
      title: 'Schwere Gegenstände',
      tip: 'Bücher, Geschirr und andere schwere Gegenstände in kleinere Kartons packen – so bleiben sie handhabbar.',
      icon: Box,
    },
    {
      title: 'Zerbrechliches',
      tip: 'Gläser, Teller und empfindliche Gegenstände einzeln in Packpapier einwickeln und Hohlräume ausfüllen.',
      icon: AlertTriangle,
    },
    {
      title: 'Beschriftung',
      tip: 'Jeden Karton beschriften mit Inhalt und Zielraum – spart Zeit beim Auspacken in der neuen Wohnung.',
      icon: Package,
    },
    {
      title: 'Kleidung',
      tip: 'Kleider-Kartons mit Stange nutzen – Hemden und Anzüge bleiben knitterfrei und müssen nicht neu gebügelt werden.',
      icon: Sparkles,
    },
  ];

  const testimonials = [
    {
      name: 'Sandra K.',
      location: 'Zürich',
      text: 'Super Qualität der Kartons! Nichts ist kaputtgegangen. Die Lieferung kam pünktlich und die Beratung war sehr hilfreich.',
      rating: 5,
    },
    {
      name: 'Michael T.',
      location: 'Basel',
      text: 'Habe das Standard-Paket bestellt – perfekt für unsere 4-Zimmer-Wohnung. Preislich absolut fair und alles dabei was man braucht.',
      rating: 5,
    },
    {
      name: 'Familie Schneider',
      location: 'Bern',
      text: 'Die Möbeldecken haben unsere Schränke perfekt geschützt. Würde ich jederzeit wieder bestellen. Top Service!',
      rating: 5,
    },
  ];

  const faqs = [
    {
      question: 'Wie viele Umzugskartons brauche ich für meinen Umzug?',
      answer: 'Als Faustregel gilt:<br><br>• <strong>1-2 Zimmer:</strong> 20-30 Kartons<br>• <strong>3-4 Zimmer:</strong> 40-60 Kartons<br>• <strong>5-6 Zimmer:</strong> 70-100 Kartons<br><br>Die genaue Anzahl hängt davon ab, wie viel Sie besitzen. Planen Sie lieber ein paar Kartons mehr ein – übrige können Sie zurückgeben. Unsere <strong>Starter-, Standard- und Premium-Pakete</strong> sind optimal auf verschiedene Haushaltsgrössen abgestimmt. Bei unserem <Link to="/komplettumzug" className="text-slate-900 font-semibold hover:underline">Komplettumzug</Link> oder <Link to="/teilumzug" className="text-slate-900 font-semibold hover:underline">Teilumzug</Link> beraten wir Sie gerne.'
    },
    {
      question: 'Kann ich die Umzugskartons nach dem Umzug zurückgeben?',
      answer: 'Ja, wir nehmen <strong>unbenutzte und saubere Kartons</strong> innerhalb von 30 Tagen zurück und erstatten den Kaufpreis. Auch <strong>gebrauchte Kartons</strong> nehmen wir gerne zurück – diese werden gereinigt und wiederverwendet. Das ist gut für die Umwelt und Sie können damit Geld sparen. Kontaktieren Sie uns einfach nach Ihrem Umzug für die Rücknahme.'
    },
    {
      question: 'Wie schnell kann ich das Verpackungsmaterial erhalten?',
      answer: '<strong>Standard-Lieferung:</strong> Bestellung bis 12 Uhr = Lieferung am nächsten Werktag<br><strong>Express-Lieferung:</strong> Lieferung am gleichen Tag möglich (Aufpreis CHF 50.–)<br><br>Die Lieferung ist <strong>kostenlos ab CHF 200.–</strong> Bestellwert. Bei kleineren Bestellungen berechnen wir CHF 25.– Lieferpauschale. Wir liefern in die ganze Schweiz.'
    },
    {
      question: 'Was ist der Unterschied zwischen Standard-Kartons und Bücher-Kartons?',
      answer: '<strong>Standard-Kartons (60x33x34cm):</strong><br>• Grösser, für leichte bis mittelschwere Gegenstände<br>• Ideal für Kleidung, Bettwäsche, Küchenutensilien<br>• Fassungsvermögen: ca. 67 Liter<br><br><strong>Bücher-Kartons (40x30x30cm):</strong><br>• Kleiner, für schwere Gegenstände<br>• Perfekt für Bücher, Geschirr, Werkzeug<br>• Fassungsvermögen: ca. 36 Liter<br>• Bleiben handhabbar auch wenn voll beladen'
    },
    {
      question: 'Sind die Umzugskartons stabil genug für einen Transport nach Deutschland?',
      answer: 'Ja, absolut! Wir verwenden ausschliesslich <strong>zweiwellige Qualitätskartons</strong>, die speziell für Umzüge konzipiert sind. Diese Kartons sind:<br><br>• Extrem belastbar (bis 30kg Tragkraft)<br>• Stapelbar ohne durchzudrücken<br>• Geeignet für internationale Transporte<br>• Feuchtigkeitsresistent<br><br>Tausende unserer Kartons haben bereits erfolgreich die Reise bei <Link to="/umzug-zuerich-deutschland" className="text-slate-900 font-semibold hover:underline">Umzügen Zürich Deutschland</Link>, <Link to="/umzug-basel-deutschland" className="text-slate-900 font-semibold hover:underline">Umzügen Basel Deutschland</Link> und anderen Routen gemeistert – ohne Beschädigungen.'
    },
    {
      question: 'Brauche ich spezielle Kartons für Gläser und Geschirr?',
      answer: 'Für <strong>wertvolles Geschirr und Gläser</strong> empfehlen wir dringend unsere <strong>Gläser-Kartons mit Einsatz (CHF 8.50)</strong>. Diese haben:<br><br>• Separate Fächer für jeden Gegenstand<br>• Kreuzeinlagen zur Trennung<br>• Extra stabile Wände<br>• Optimal für Weingläser, Tassen, Teller<br><br>Alternativ können Sie Standard-Kartons verwenden, sollten aber jedes Teil einzeln in Packpapier oder Luftpolsterfolie einwickeln und Hohlräume ausfüllen.'
    },
    {
      question: 'Was sind Kleider-Kartons und wofür brauche ich sie?',
      answer: '<strong>Kleider-Kartons (CHF 12.00)</strong> haben eine integrierte Kleiderstange und sind perfekt für:<br><br>• Hemden und Blusen (bleiben knitterfrei)<br>• Anzüge und Kostüme<br>• Kleider und Mäntel<br>• Andere Kleidung auf Bügeln<br><br>Der grosse Vorteil: Die Kleidung kann direkt auf den Bügeln bleiben, wird transportiert und in der neuen Wohnung sofort in den Schrank gehängt. Kein Knittern, kein Bügeln nötig!'
    },
    {
      question: 'Welches Material ist am besten zum Schutz von Möbeln?',
      answer: 'Für den optimalen Möbelschutz empfehlen wir:<br><br><strong>Möbeldecken (CHF 12.00/Stück):</strong><br>• Beste Lösung für Schränke, Tische, Kommoden<br>• Wiederverwendbar, waschbar<br>• Schützen vor Kratzern und Stössen<br><br><strong>Stretchfolie (CHF 22.00):</strong><br>• Hält Schubladen und Türen geschlossen<br>• Schützt vor Schmutz und Feuchtigkeit<br>• Perfekt für Sofas und Sessel<br><br><strong>Luftpolsterfolie (CHF 28.00):</strong><br>• Für empfindliche Oberflächen<br>• Schutz vor Kratzern und Dellen'
    },
    {
      question: 'Gibt es Mengenrabatte bei grösseren Bestellungen?',
      answer: 'Ja, wir bieten attraktive Mengenrabatte:<br><br>• <strong>Ab 50 Kartons:</strong> 10% Rabatt<br>• <strong>Ab 100 Kartons:</strong> 15% Rabatt<br>• <strong>Ab 200 Kartons:</strong> 20% Rabatt<br><br>Die Rabatte gelten für Kartons und können nicht mit anderen Aktionen kombiniert werden. Bei Fragen zu grösseren Bestellungen kontaktieren Sie uns gerne – wir erstellen Ihnen eine individuelle Offerte.'
    },
    {
      question: 'Kann ich auch nur einzelne Artikel bestellen oder muss ich ein Paket nehmen?',
      answer: 'Sie können <strong>einzelne Artikel oder komplette Pakete</strong> bestellen – ganz wie Sie möchten. Unsere Pakete (Starter, Standard, Premium) sind vorkonfiguriert und bieten einen <strong>Preisvorteil gegenüber Einzelbestellung</strong> von etwa 15-20%.<br><br>Wenn Sie spezielle Bedürfnisse haben oder nur einzelne Materialien brauchen, können Sie natürlich auch individuell bestellen. Bei Buchung eines <Link to="/komplettumzug" className="text-slate-900 font-semibold hover:underline">Komplettumzugs</Link> oder <Link to="/express-umzuege" className="text-slate-900 font-semibold hover:underline">Express-Umzugs</Link> erhalten Sie Sonderkonditionen. Kontaktieren Sie uns für eine persönliche Beratung!'
    }
  ];

  const deliveryInfo = [
    {
      title: 'Kostenlose Lieferung',
      text: 'Ab CHF 200.– Bestellwert liefern wir kostenlos in die ganze Schweiz',
    },
    {
      title: 'Express-Lieferung',
      text: 'Dringend? Express-Lieferung am gleichen Tag möglich (Aufpreis CHF 50.–)',
    },
    {
      title: 'Rücknahme-Service',
      text: 'Unbenutzte Kartons nehmen wir innerhalb 30 Tagen zurück',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-20 min-h-[700px] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px'
          }} />
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold mb-6 border border-white/20">
              Professionelles Verpackungsmaterial
            </div>

            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              Verpackungsmaterial für Ihren Umzug
            </h1>

            <p className="text-xl md:text-2xl text-slate-200 mb-8 leading-relaxed">
              Hochwertige Umzugskartons und Verpackungsmaterial – schnell geliefert und umweltfreundlich
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
              <button
                onClick={scrollToContact}
                className="bg-white text-slate-900 px-8 py-4 rounded-lg font-semibold hover:bg-slate-100 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 flex items-center justify-center space-x-2"
              >
                <span>Jetzt Material bestellen</span>
                <ArrowRight className="w-5 h-5" />
              </button>
              <a
                href="tel:0800700100"
                className="bg-slate-700/50 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold hover:bg-slate-700 transition-all duration-300 border border-white/20 flex items-center justify-center space-x-2"
              >
                <Phone className="w-5 h-5" />
                <span>0800 700 100</span>
              </a>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              {benefits.slice(0, 3).map((benefit, index) => (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                  <CheckCircle2 className="w-6 h-6 text-green-400 mb-2 mx-auto" />
                  <p className="text-sm font-medium">{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Unser Sortiment
              </h2>
              <p className="text-xl text-slate-600">
                Alles was Sie für einen sicheren Umzug brauchen
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {materials.map((category, index) => {
                const Icon = category.icon;
                return (
                  <div key={index} className="bg-slate-50 rounded-2xl p-8 border-2 border-slate-100 hover:border-slate-300 transition-all duration-300">
                    <div className="bg-slate-800 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-3">{category.title}</h3>
                    <p className="text-slate-600 mb-6">{category.description}</p>
                    <ul className="space-y-3">
                      {category.items.map((item, idx) => (
                        <li key={idx} className="flex justify-between items-center py-2 border-b border-slate-200">
                          <span className="text-slate-700">{item.name}</span>
                          <span className="font-bold text-slate-900">{item.price}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Unsere Komplett-Pakete
              </h2>
              <p className="text-xl text-slate-600">
                Perfekt abgestimmt auf verschiedene Haushaltsgrössen
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {packages.map((pkg, index) => (
                <div
                  key={index}
                  className={`rounded-2xl p-8 border-2 transition-all duration-300 ${
                    pkg.popular
                      ? 'bg-slate-900 border-slate-900 text-white scale-105'
                      : 'bg-white border-slate-200 hover:border-slate-800'
                  }`}
                >
                  {pkg.popular && (
                    <div className="bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">
                      BELIEBTESTES PAKET
                    </div>
                  )}
                  <h3 className={`text-2xl font-bold mb-2 ${pkg.popular ? 'text-white' : 'text-slate-900'}`}>
                    {pkg.name}
                  </h3>
                  <p className={`text-sm mb-4 ${pkg.popular ? 'text-slate-300' : 'text-slate-600'}`}>
                    {pkg.ideal}
                  </p>
                  <div className={`text-4xl font-bold mb-6 ${pkg.popular ? 'text-white' : 'text-slate-900'}`}>
                    {pkg.price}
                  </div>
                  <div className={`border-t mb-6 ${pkg.popular ? 'border-slate-700' : 'border-slate-200'}`} />
                  <ul className="space-y-3">
                    {pkg.contents.map((item, idx) => (
                      <li key={idx} className="flex items-start space-x-2">
                        <CheckCircle2
                          className={`w-5 h-5 flex-shrink-0 mt-0.5 ${
                            pkg.popular ? 'text-green-400' : 'text-green-600'
                          }`}
                        />
                        <span className={`text-sm ${pkg.popular ? 'text-slate-200' : 'text-slate-700'}`}>
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <button
                    onClick={scrollToContact}
                    className={`w-full mt-8 px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                      pkg.popular
                        ? 'bg-white text-slate-900 hover:bg-slate-100'
                        : 'bg-slate-900 text-white hover:bg-slate-800'
                    }`}
                  >
                    Paket bestellen
                  </button>
                </div>
              ))}
            </div>

            <div className="mt-8 text-center">
              <p className="text-slate-600">
                * Alle Pakete inkl. kostenlose Lieferung. Sparen Sie 15-20% gegenüber Einzelbestellung!
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Warum unser Verpackungsmaterial?
              </h2>
              <p className="text-xl text-slate-600">
                Qualität, Service und Nachhaltigkeit
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              {whyChooseUs.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={index} className="bg-slate-50 rounded-2xl p-8 border-2 border-slate-100 hover:border-slate-300 transition-all duration-300 hover:shadow-lg">
                    <div className="bg-slate-800 w-14 h-14 rounded-xl flex items-center justify-center mb-6">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900 mb-3">{item.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{item.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Professionelle Pack-Tipps
              </h2>
              <p className="text-xl text-slate-600">
                So verpacken Sie richtig
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              {packingTips.map((tip, index) => {
                const Icon = tip.icon;
                return (
                  <div key={index} className="bg-white rounded-2xl p-6 border-2 border-slate-100">
                    <div className="flex items-start space-x-4">
                      <div className="bg-slate-100 w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0">
                        <Icon className="w-6 h-6 text-slate-800" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-slate-900 mb-2">{tip.title}</h3>
                        <p className="text-slate-600 leading-relaxed">{tip.tip}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Lieferung & Service
              </h2>
              <p className="text-xl text-slate-600">
                Schnell, zuverlässig und kundenfreundlich
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {deliveryInfo.map((info, index) => (
                <div key={index} className="bg-slate-50 rounded-2xl p-6 text-center border-2 border-slate-100">
                  <CheckCircle2 className="w-12 h-12 text-green-600 mx-auto mb-4" />
                  <h3 className="text-xl font-bold text-slate-900 mb-2">{info.title}</h3>
                  <p className="text-slate-600">{info.text}</p>
                </div>
              ))}
            </div>

            <div className="mt-12 bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-8 border-2 border-blue-200">
              <div className="text-center">
                <h3 className="text-2xl font-bold text-slate-900 mb-4">
                  Bestellung aufgeben
                </h3>
                <p className="text-slate-700 mb-6">
                  Rufen Sie uns an oder schreiben Sie uns – wir beraten Sie gerne zu Ihrem Bedarf und liefern schnell.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a
                    href="tel:0800700100"
                    className="bg-slate-900 text-white px-8 py-3 rounded-lg font-semibold hover:bg-slate-800 transition-all duration-300 inline-flex items-center justify-center space-x-2"
                  >
                    <Phone className="w-5 h-5" />
                    <span>0800 700 100</span>
                  </a>
                  <button
                    onClick={scrollToContact}
                    className="bg-white text-slate-900 px-8 py-3 rounded-lg font-semibold hover:bg-slate-100 transition-all duration-300 border-2 border-slate-200 inline-flex items-center justify-center space-x-2"
                  >
                    <span>Beratung anfordern</span>
                    <ArrowRight className="w-5 h-5" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Das sagen unsere Kunden
              </h2>
              <p className="text-xl text-slate-600">
                Zufriedene Kunden in der ganzen Schweiz
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="bg-white rounded-2xl p-6 border-2 border-slate-100">
                  <div className="flex items-center mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <p className="text-slate-700 mb-4 leading-relaxed">"{testimonial.text}"</p>
                  <div className="border-t border-slate-200 pt-4">
                    <div className="font-semibold text-slate-900">{testimonial.name}</div>
                    <div className="text-sm text-slate-500">{testimonial.location}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Häufig gestellte Fragen
              </h2>
              <p className="text-xl text-slate-600">
                Alles über Verpackungsmaterial für Ihren Umzug
              </p>
            </div>

            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-slate-50 rounded-xl border-2 border-slate-100 overflow-hidden transition-all duration-300 hover:border-slate-300"
                >
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left"
                  >
                    <span className="font-semibold text-slate-900 pr-4">{faq.question}</span>
                    <ChevronDown
                      className={`w-5 h-5 text-slate-600 transition-transform duration-300 flex-shrink-0 ${
                        openFaq === index ? 'transform rotate-180' : ''
                      }`}
                    />
                  </button>
                  {openFaq === index && (
                    <div className="px-6 pb-5">
                      <p className="text-slate-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Contact />
    </div>
  );
}
